document.addEventListener('DOMContentLoaded', function() {
  // Sob variant option label select koro
  const optionLabels = document.querySelectorAll('.variant-picker__option-info, .product-form__option-label');

  optionLabels.forEach(label => {
    // current text
    let text = label.textContent;

    // dash (—) er porer text show koro
    if (text.includes('—')) {
      label.textContent = text.split('—')[1].trim();
    }
  });
});





document.addEventListener('DOMContentLoaded', function() {
  const accordions = document.querySelectorAll('details.accordion');

  accordions.forEach((acc) => {
    acc.addEventListener('click', function(e) {

      if (e.target.closest('summary')) {
        accordions.forEach((otherAcc) => {
          if (otherAcc !== acc) {
            otherAcc.removeAttribute('open');
          }
        });
      }
    });
  });
});











